import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vad är ett bulvanförhållande?";
const SHORT_ANSWER = "När någon formellt står som ägare eller tillståndshavare men någon annan reellt styr verksamheten. Det är otillåtet och leder till avslag eller återkallat tillstånd.";

export const Route = createFileRoute("/fraga/vad-ar-bulvanforhallanden")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vad är ett bulvanförhållande" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Klassiska tecken: nyregistrerat bolag, formell ägare utan branscherfarenhet, en 'rådgivare' som sköter allt operativt, finansiering från okänd part. Kommunen är vaksam mot detta."}
      source={{ label: "Folkhälsomyndigheten – Serveringstillstånd (vägledning)", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/" }}
      extraSources={[]}
      deepGuide={{ to: "/pbi-krets", label: "Bulvanförhållanden – varningssignaler" }}
      related={[{"to": "/fraga/vem-galler-som-styrelseledamot-vid-pbi-prov", "label": "Räknas alla styrelseledamöter i PBI-kretsen?"}, {"to": "/fraga/vilken-aldersgrans-galler-for-servering", "label": "Vilken åldersgräns gäller för servering av alkohol?"}, {"to": "/fraga/hur-lang-tid-tillbaka-tittar-kommunen", "label": "Hur långt tillbaka tittar kommunen vid lämplighetsprövning?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vad är ett bulvanförhållande?" },
      { name: "description", content: "När någon formellt står som ägare eller tillståndshavare men någon annan reellt styr verksamheten. Det är otillåtet och leder till avslag eller återkallat ti…" },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vad-ar-bulvanforhallanden" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vad-ar-bulvanforhallanden" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vad-ar-bulvanforhallanden",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vad är ett bulvanförhållande", url: "https://alkoholprovet.se/fraga/vad-ar-bulvanforhallanden" },
      ]),
    ],
  }),
});
